import { Box } from '@talos/kyoko';

/**
 * Temporary body used while mobile panel content is not yet implemented. Reserves space matching a real
 * panel (safe-area insets, tall scroll area) so the tab bar behaves the same as in the real flow.
 */
export function TradingPlaceholder({ label }: { label: string }) {
  return (
    <Box
      data-testid="mobile-trading-placeholder"
      h="200dvh"
      background="backgroundContent"
      mb="env(safe-area-inset-bottom)"
      flex="1 0 auto"
      pt="env(safe-area-inset-top)"
    >
      {label}
    </Box>
  );
}
